// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PeVA1","label":"styles_label__2NdPv"};